import { useState } from 'react'
import axios from 'axios'
import { configService } from '../services/configService'
import type { ExchangeSettingsFormData, CategoriesFormData, Product } from '../types'

export function useConfigMutation() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const clearMessages = () => {
    setError(null)
    setSuccess(null)
  }

  const updateExchangeSettings = async (data: ExchangeSettingsFormData) => {
    setIsSubmitting(true)
    clearMessages()
    try {
      await configService.updateExchangeSettings(data)
      setSuccess('Datos actualizados correctamente')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar configuración')
      } else {
        setError('Error al actualizar configuración')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const updateCategories = async (data: CategoriesFormData) => {
    setIsSubmitting(true)
    clearMessages()
    try {
      await configService.updateCategories(data)
      setSuccess('Categorías actualizadas correctamente')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar categorías')
      } else {
        setError('Error al actualizar categorías')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const updateEmails = async (emailsString: string) => {
    setIsSubmitting(true)
    clearMessages()
    try {
      const emailArray = emailsString.split(',').map((e) => e.trim()).filter(Boolean)
      const emailObject: Record<string, string> = {}
      emailArray.forEach((email, index) => {
        emailObject[`email${index + 1}`] = email
      })
      await configService.updateEmails(emailObject)
      setSuccess('Correos actualizados correctamente')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar correos')
      } else {
        setError('Error al actualizar correos')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const updateProducts = async (products: Product[]) => {
    setIsSubmitting(true)
    clearMessages()
    try {
      await configService.updateProducts(products)
      setSuccess('Productos actualizados correctamente')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar productos')
      } else {
        setError('Error al actualizar productos')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    updateExchangeSettings,
    updateCategories,
    updateEmails,
    updateProducts,
    isSubmitting,
    error,
    success,
    clearMessages,
  }
}
